<script setup>

import {useRoute} from "vue-router";
import {storeToRefs} from "pinia";
import {ref} from "vue";
import {useUserSessionQuizStore} from "@/stores/userSessionQuiz.store";

const route = useRoute();
const userSessionQuizStore = useUserSessionQuizStore();
userSessionQuizStore.fetchOne(route.params.id);
const {userQuiz} = storeToRefs(userSessionQuizStore);
const name = ref(1);

const updateResource = async () => {
  const userSelectedAnswerIds = userQuiz.value.treatment_session_quiz.questions.map(item => item.user_selected);
  await userSessionQuizStore.update(route.params.id, userSelectedAnswerIds);
  await userSessionQuizStore.fetchOne(route.params.id);
}

</script>

<template>
  <van-form @submit="updateResource">
    <van-cell-group inset>
      <van-collapse v-model="name" accordion>
        <van-collapse-item name="1">
          <template #title>
            <b>{{userQuiz.treatment_session_quiz.name}}</b>
          </template>
          {{ userQuiz.treatment_session_quiz.description }}
        </van-collapse-item>
      </van-collapse>
      <van-cell title="Status">
        <template #value>
          <van-tag round size="medium"  type="primary">{{userQuiz.status}}</van-tag>
        </template>
      </van-cell>
      <van-cell title="Created By" :value="userQuiz.created_by_user"/>
      <van-cell title="Created" :value="userQuiz.created_at_formatted"/>
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset v-for="question in userQuiz.treatment_session_quiz.questions"
                    :key="question.id">
      <van-cell>
        <template #title>
          <b>{{ question.question }}</b>
        </template>
      </van-cell>

      <van-radio-group
          v-for="answer in question.answers"
          :key="answer.id"
          v-model="question.user_selected"
      >
        <van-cell
            :title="answer.answer"
            clickable
        >
          <template #right-icon>
            <van-radio :name="answer.id"/>
          </template>
        </van-cell>
      </van-radio-group>

      <van-divider/>
    </van-cell-group>

    <van-cell-group inset>
      <van-button v-if="userQuiz.status !== 'Passed' " block round type="success" native-type="submit">
        Submit
      </van-button>
    </van-cell-group>

  </van-form>
</template>

<style>

:root:root {
    --van-radio-border-color: #000;
}

</style>
